module.exports = __webpack_public_path__ + "5f80e2b1fe2352fbe3f757c44ab1d590.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansbolditalic.woff2
// module id = 675
// module chunks = 57